module.exports = __webpack_public_path__ + "static/img/bg-corona.3363654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-corona.png
// module id = DLzR
// module chunks = 1